/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface JobStatus
 */
export interface JobStatus {
  /**
   *
   * @type {number}
   * @memberof JobStatus
   */
  pending: number;
  /**
   *
   * @type {number}
   * @memberof JobStatus
   */
  running: number;
  /**
   *
   * @type {number}
   * @memberof JobStatus
   */
  completed: number;
  /**
   *
   * @type {number}
   * @memberof JobStatus
   */
  failed: number;
  /**
   *
   * @type {number}
   * @memberof JobStatus
   */
  cancelled: number;
}

/**
 * Check if a given object implements the JobStatus interface.
 */
export function instanceOfJobStatus(value: object): value is JobStatus {
  if (!('pending' in value) || value['pending'] === undefined) return false;
  if (!('running' in value) || value['running'] === undefined) return false;
  if (!('completed' in value) || value['completed'] === undefined) return false;
  if (!('failed' in value) || value['failed'] === undefined) return false;
  if (!('cancelled' in value) || value['cancelled'] === undefined) return false;
  return true;
}

export function JobStatusFromJSON(json: any): JobStatus {
  return JobStatusFromJSONTyped(json, false);
}

export function JobStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobStatus {
  if (json == null) {
    return json;
  }
  return {
    pending: json['pending'],
    running: json['running'],
    completed: json['completed'],
    failed: json['failed'],
    cancelled: json['cancelled'],
  };
}

export function JobStatusToJSON(value?: JobStatus | null): any {
  if (value == null) {
    return value;
  }
  return {
    pending: value['pending'],
    running: value['running'],
    completed: value['completed'],
    failed: value['failed'],
    cancelled: value['cancelled'],
  };
}
